import { subtract, sum } from "lodash";
import FormulaLayoutUI from "./FormulaLayoutUI";

const TransporterBalance = ({ totalFreight, tdsDeduction, freight_deduction, miller_advance, transporterAdvance }) => {
  const total = Number(totalFreight ?? 0);
  const deduction = Number(tdsDeduction ?? 0);
  const freightDeduction = Number(freight_deduction ?? 0); 
  const MillerAdvance = Number(miller_advance ?? 0);
  const advance = Number(transporterAdvance ?? 0);
  

  const balance = subtract(total, sum([deduction, freightDeduction, MillerAdvance, advance])).toFixed(2);

  return (
  <FormulaLayoutUI>

    <div style={{ marginBottom: "12px" }}>
      <strong style={{ fontSize: "15px" }}>Transporter Balance Formula</strong>
    </div>

    <div
      style={{
        padding: "10px 12px",
        border: "1px solid #e0e0e0",
        borderRadius: "6px",
        fontSize: "13px",
        marginBottom: "10px",
      }}
    >
      <div>
        Transporter Balance = Total Freight − (TDS Deduction + Freight Deduction + Miller Advance + Transporter Advance )
      </div>

      <div style={{ marginTop: "6px", color: "#555" }}>
        = {total} − ({deduction} + {freightDeduction} + {MillerAdvance} + {advance} )
      </div>

      <div style={{ marginTop: "6px" }}>
        = {total} − {deduction + freightDeduction + MillerAdvance + advance}
      </div>

      <div
        style={{
          marginTop: "10px",
          fontSize: "15px",
          fontWeight: 600,
        }}
      >
        Balance Amount: ₹ {balance} /-
      </div>
    </div>

  </FormulaLayoutUI>
);
};

export default TransporterBalance;
